import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import NoPlatformChargeContent from './NoPlatformChargeContent';

const NoPlatformCharge = () => (
  <>
    <Helmet>
      <title>WhatsApp Business API with No Platform Fee | HAWKTRION</title>
      <meta name="description" content="Use the HAWKTRION WhatsApp Business API platform with no monthly platform fee. Meta messaging charges and optional integration costs may still apply." />
      <meta name="keywords" content="WhatsApp Business API no platform fee, WhatsApp API pricing, WhatsApp Cloud API platform" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/free-whatsapp-business-api/" />
      <meta property="og:title" content="WhatsApp Business API with No Platform Fee | HAWKTRION" />
      <meta property="og:description" content="Use the HAWKTRION WhatsApp Business API platform with no monthly platform fee. Meta messaging charges and optional integration costs may still apply." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/free-whatsapp-business-api/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp Business API with No Platform Fee | HAWKTRION" />
      <meta name="twitter:description" content="Use the HAWKTRION WhatsApp Business API platform with no monthly platform fee. Meta messaging charges and optional integration costs may still apply." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp Business API Without Monthly Platform Fees" hideCta>
      <NoPlatformChargeContent />
    </SeoLandingPage>
  </>
);

export default NoPlatformCharge;